import { render, staticRenderFns } from "./BenefitsCreate.vue?vue&type=template&id=2921380b"
import script from "./BenefitsCreate.vue?vue&type=script&lang=js"
export * from "./BenefitsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports